<script lang="ts" setup>
import { MText } from '#components'

interface Prop {
  tag?: string
  root?: number
  size?: Size
  placement?: Placement
}

const props = defineProps<Prop>()
</script>
<template>
  <component class=" flex items-center" :is="$attrs.is ?? MText" v-bind="props">
    <slot></slot>
  </component>
</template>
